module.exports = __webpack_public_path__ + "static/NeueEinstellungNormal-dc127416780107c106d8624ae9612465.woff";